module.exports = __webpack_public_path__ + "static/media/image-06-full.4bde0258.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-06-full.jpg
// module id = 348
// module chunks = 0